import './style.scss';
import Breadcrumbs from './breadcrumbs.js';

export default Breadcrumbs;